<div class='w-400 mw-full t-c m-l-a m-r-a t-l p-25'>
    <img class="dialogClose" src="../../assets/icons/fi_close.svg" alt="Close"
        (click)="closeDialog()">

    <form [formGroup]="reportForm" class='reportForm' (ngSubmit)="onReportFormSubmit()">
        <div class=' report-heading'>Report Abuse</div>

        <div class="form-group ">
            <input type="text" class="form-control" [ngClass]="{'is-invalid':formSubmit && url.errors?.required}" formControlName="url" placeholder="Which content do you wish to report">
            <mat-hint [ngClass]="{'mat-error':formSubmit && url.errors?.required}">Please list all Songdew URL's which you want to report abuse</mat-hint>
        </div>
      
        <div class="form-group ">
            <input type="text" formControlName="complaint" class="form-control pointer icon-rtl" autocomplete="off"
                readonly [value]="complaint" [ngClass]="{'is-invalid':formSubmit && complaint.errors?.required}"
                placeholder="Type of Complaint" id="complaint" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
            <div style="position: absolute;top: -10px;width: 100%;left: 0px;">
                <div class="dropdown-menu " aria-labelledby="complaint" id="manualdrop">
                    <img src="assets/images/sd-chevron-up.svg"
                        style="position: absolute; right: 0px; margin-right: 10px; margin-top: 5px !important;">
                    <div *ngFor="let complaint of complaints">
                        <a class="dropdown-item" (click)="dropvalueValidate(complaint)">
                            <span> {{complaint}}</span>
                        </a>
                    </div>
                </div>

            </div>
            <mat-error *ngIf="formSubmit && complaint.errors?.required"> Please select atleast 1 type</mat-error>
        </div>


    
        <div class="form-group ">
            <input type="text" class="form-control" [ngClass]="{'is-invalid':formSubmit && description.errors?.required}" formControlName="description" placeholder="Detailed Information">
            <mat-hint [ngClass]="{'mat-error':formSubmit && description.errors?.required}">Please provide detailed information about your complaint</mat-hint>
        </div>


        <div class='sub-heading'>Provide your contact details</div>

   
        <div class="form-group ">
            <label>Name*</label>
            <input type="text" class="form-control" [ngClass]="{'is-invalid':formSubmit && name.errors?.required}" formControlName="name" placeholder="Name">
            <mat-error *ngIf=" formSubmit && name.errors?.required">
                Please enter your name
            </mat-error>
        </div>
 

        <div class="form-group ">
            <label>Email*</label>
            <input type="text" [ngClass]="{'is-invalid':formSubmit && email.errors?.required}" class="form-control" formControlName="email" placeholder="Email">
            <mat-error *ngIf="formSubmit && email.errors?.required">
                Please enter your email ID
            </mat-error>
            <mat-error *ngIf="!email.errors?.required && email.dirty && email.errors?.email">
                Please enter a valid email ID
            </mat-error>
            <mat-error *ngIf="!email.errors?.required && email.dirty && !email.errors?.email && email.errors?.pattern">
                Please enter a valid email ID
            </mat-error>

        </div>

        

        <div class="form-group ">
            <label>Mobile</label>
            <input type="text" class="form-control" [ngClass]="{'is-invalid':formSubmit && mobile.errors?.validMobile}" formControlName="mobile" placeholder="Mobile">
            <mat-error *ngIf="formSubmit && mobile.errors?.validMobile">
                Please enter a valid 10 digit mobile number
            </mat-error>
        </div>

        <div class="w-full flex-col-sb-c m-t-20">
            <re-captcha formControlName="recaptchaReactive"></re-captcha>
            <mat-error *ngIf="recaptchaError && recaptchaReactive.errors?.required" class='m-t-10'>
                Please prove that you're not a robot
            </mat-error>
        </div>

        <div *ngIf="reportError" class='text-danger m-t-10'>{{reportErrorMsg}}</div>

        <div class='flex-c-c m-t-20'>
            <button class='button' [disabled]="processing"
                type='submit'>{{(processing)?'Reporting':'Report'}}</button>
        </div>
    </form>
</div>
